import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yiliao",
  "use": "icon-yiliao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yiliao\"><defs><style type=\"text/css\"></style></defs><path d=\"M832 928H192c-54.4 0-96-41.6-96-96V352h832v480c0 54.4-41.6 96-96 96z m-160-352h-96v-96h-128v96h-96v128h96v96h128v-96h96v-128zM96 192c0-54.4 41.6-96 96-96h640c54.4 0 96 41.6 96 96v96H96V192z\" p-id=\"2765\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol